import { styled } from '@mui/material';
import { Props } from './types';
import { SIZES } from '../../theme/overrides/Checkbox';

const ENABLED_CHECKBOX =
  "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
  " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
  "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")";

const DISABLED_CHECKBOX =
  "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
  " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
  "1.003%200%2000-1.42%201.42l3%203c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003%201.003%200%200012%205z' fill%3D'%23A4A7AE'%2F%3E%3C%2Fsvg%3E\")";

const ENABLED_INDETERMINATE_CHECKBOX =
  "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath" +
  " fill-rule='evenodd' clip-rule='evenodd' d='M19 13H5v-2h14z'" +
  " fill='%23fff'/%3E%3C/svg%3E\")";

const DISABLED_INDETERMINATE_CHECKBOX =
  "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath" +
  " fill-rule='evenodd' clip-rule='evenodd' d='M19 13H5v-2h14z'" +
  " fill%3D'%23A4A7AE'%2F%3E%3C%2Fsvg%3E\")";

export const StyledCheckbox = styled('span')<{
  size: NonNullable<Props['size']>;
  disabled?: NonNullable<Props['disabled']>;
}>(({ theme, size, disabled }) => {
  return {
    '&::before': {
      borderRadius: theme.spacing(1),
      width: SIZES[size].width,
      height: SIZES[size].height,
      display: 'block',
      backgroundImage: ENABLED_CHECKBOX,
      content: '""',
      ...(disabled && {
        borderColor: theme.palette.foreground.quinary,
        border: '1px solid',
        backgroundColor: theme.palette.background.disabled,
        backgroundImage: DISABLED_CHECKBOX,
      }),
    },
  };
});

export const StyledIntermittentCheckbox = styled('span')<{
  size: NonNullable<Props['size']>;
  disabled?: NonNullable<Props['disabled']>;
}>(({ theme, size, disabled }) => {
  return {
    '&::before': {
      borderRadius: theme.spacing(1),
      backgroundImage: ENABLED_INDETERMINATE_CHECKBOX,
      ...(disabled && {
        borderColor: theme.palette.foreground.quinary,
        border: '1px solid',
        backgroundColor: theme.palette.background.disabled,
        backgroundImage: DISABLED_INDETERMINATE_CHECKBOX,
      }),
      width: SIZES[size].width,
      height: SIZES[size].height,
      display: 'block',
      content: '""',
    },
  };
});
